module.exports = __webpack_public_path__ + "img/phone.6e880a73.svg";